var _g, _g2, _path, _rect, _path2, _path3, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProviderMarker(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 45,
    viewBox: "0 0 38 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_405_113807)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 18.668,
    cy: 38.5,
    rx: 4,
    ry: 1,
    fill: "black",
    fillOpacity: 0.2
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_405_113807)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19 4C26.732 4 33 10.5239 33 18.5714C33 24.7419 29.3151 30.0165 24.1107 32.1415L19.7972 38.278C19.7073 38.4065 19.5879 38.5113 19.4491 38.5837C19.3103 38.6561 19.1562 38.6939 18.9998 38.6939C18.8434 38.6939 18.6893 38.6561 18.5506 38.5837C18.4118 38.5113 18.2924 38.4065 18.2024 38.278L13.8889 32.1413C8.68474 30.0162 5 24.7417 5 18.5714C5 10.5239 11.268 4 19 4Z",
    fill: "white"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.8041 18.5709C30.8041 11.7857 25.5193 6.28516 19.0002 6.28516C12.4811 6.28516 7.19629 11.7857 7.19629 18.5709C7.19629 25.3561 12.4811 30.8566 19.0002 30.8566C25.5193 30.8566 30.8041 25.3561 30.8041 18.5709Z",
    fill: "#EAF5FE"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 13.6709,
    y: 15.9043,
    width: 10.1111,
    height: 10.3842,
    fill: "#28325A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.782 26.2885H13.6709V15.9043L23.782 26.2885Z",
    fill: "#FFBD33"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.6103 15.7807L18.6763 8.59549C18.704 8.56713 18.7491 8.56713 18.7769 8.59549L25.8429 15.7807C25.8877 15.8263 25.8559 15.9042 25.7926 15.9042H11.6605C11.5972 15.9042 11.5656 15.8263 11.6103 15.7807Z",
    fill: "#5196CB"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_405_113807",
    x: 12.668,
    y: 35.5,
    width: 12,
    height: 6,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    result: "effect1_foregroundBlur_405_113807"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_405_113807",
    x: 0,
    y: 0,
    width: 38,
    height: 44.6934,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_405_113807"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_405_113807",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProviderMarker);
export default __webpack_public_path__ + "static/media/providerMarker.c329debe86ede37f99dd30bde9ea6de3.svg";
export { ForwardRef as ReactComponent };